import { call, put, takeLatest } from 'redux-saga/effects';
import {
  cancelInvoiceFailure,
  cancelInvoiceRequest,
  cancelInvoiceSuccess,
  transmitInvoiceToPeppolFailure,
  transmitInvoiceToPeppolRequest,
  transmitInvoiceToPeppolSuccess,
} from './invoicesSlice';
import { apiClient } from '../../utils/axios';
import { showSnackbar } from '../snackbarSlice';

function* cancelInvoiceSaga(action) {
  try {
    const { url, reason } = action.payload;
    const data = { reason };
    const response = yield call(apiClient.put, url, data);
    yield put(cancelInvoiceSuccess(response.data));
  } catch (error) {
    yield put(cancelInvoiceFailure(JSON.stringify(error.response?.data?.errors)));
  }
}

function* transmitInvoiceToPeppolSaga(action) {
  try {
    const { documentId } = action.payload;
    const response = yield call(apiClient.get, `/invoices/${documentId}/transmit-doc-over-peppol`);
    yield put(transmitInvoiceToPeppolSuccess(response.data));
    yield put(
      showSnackbar({
        message: response.data.message,
        severity: 'success',
      }),
    );
  } catch (error) {
    yield put(transmitInvoiceToPeppolFailure(JSON.stringify(error.message)));
    yield put(showSnackbar({ message: error.response?.data?.message, severity: 'error' }));
  }
}

function* invoiceSaga() {
  yield takeLatest(cancelInvoiceRequest.type, cancelInvoiceSaga);
  yield takeLatest(transmitInvoiceToPeppolRequest.type, transmitInvoiceToPeppolSaga);
}

export default invoiceSaga;
